import dayjs from 'dayjs';
import { DATE_TIME_FORMAT_API } from '@/std/const/date';

export function orderAdicionaisGrupos<T extends { pra_data_insercao?: string | null | undefined }>(
    adicionais: T[],
): T[] {
    return adicionais.toSorted((a, b) => {
        const dateA = a.pra_data_insercao ? dayjs(a.pra_data_insercao, DATE_TIME_FORMAT_API) : null;
        const dateB = b.pra_data_insercao ? dayjs(b.pra_data_insercao, DATE_TIME_FORMAT_API) : null;

        if (!dateA?.isValid() && !dateB?.isValid()) {
            return 0;
        }

        // itens sem data vão para o final
        if (!dateA?.isValid()) {
            return 1;
        }

        if (!dateB?.isValid()) {
            return -1;
        }

        return dateA.valueOf() - dateB.valueOf();
    });
}
